/**
 * Mat & fika – lightweight editorial surface constants.
 *
 * v1: editorial content on the producer (food_description, food_serving_types).
 * Not a standalone bounded context – intentionally lightweight.
 *
 * Offering key: `food_fika` (group: eat_drink).
 */

/** Offering keys that gate the Mat & fika surface. */
export const FOOD_FIKA_OFFERING_KEYS = ['food_fika'] as const;

/** Pre-defined serving-type chips for the editor. */
export const SERVING_TYPES = [
  { key: 'cafe', label: 'Café' },
  { key: 'gardscafe', label: 'Gårdscafé' },
  { key: 'restaurang', label: 'Restaurang' },
  { key: 'fika', label: 'Fika' },
  { key: 'lunch', label: 'Lunch' },
  { key: 'middag', label: 'Middag' },
  { key: 'brunch', label: 'Brunch' },
  { key: 'servering', label: 'Servering' },
  { key: 'picknick', label: 'Picknick' },
] as const;

export type ServingTypeKey = typeof SERVING_TYPES[number]['key'];

/** Check if producer offerings include any food_fika key. */
export function hasFoodFikaOffering(offeringKeys: string[]): boolean {
  return FOOD_FIKA_OFFERING_KEYS.some((k) => offeringKeys.includes(k));
}

/** Build a human-readable hint for the editor section summary. */
export function buildFoodFikaHint(
  description: string | null | undefined,
  servingTypes: string[],
): string {
  if (servingTypes.length > 0) {
    const labels = servingTypes
      .map((k) => SERVING_TYPES.find((s) => s.key === k)?.label ?? k)
      .slice(0, 3);
    return labels.join(', ') + (servingTypes.length > 3 ? ' …' : '');
  }
  if (description) return 'Beskrivning tillagd';
  return 'Berätta om er mat & fika';
}
